import React from 'react'
import { Card, CardContent, CardHeader, Separator } from '@/shared/ui'
import { MentionAutocomplete, type MentionUser } from '@/shared/ui/MentionAutocomplete'

const DEMO_USERS: MentionUser[] = [
  {
    id: '11111111-1111-1111-1111-111111111111',
    full_name: 'Usuário Demo 1',
    avatar_url: null,
  },
  {
    id: '22222222-2222-2222-2222-222222222222',
    full_name: 'Usuário Demo 2',
    avatar_url: null,
  },
  {
    id: '33333333-3333-3333-3333-333333333333',
    full_name: 'Usuário Demo 3',
    avatar_url: null,
  },
]

export default function DesignSystemPage() {
  const [activeIndex, setActiveIndex] = React.useState(0)
  const [selected, setSelected] = React.useState<MentionUser | null>(null)
  const [query, setQuery] = React.useState('')

  const users = React.useMemo(() => {
    const q = String(query || '').trim().toLowerCase()
    if (!q) return DEMO_USERS
    return DEMO_USERS.filter((u) =>
      String(u.full_name || '').toLowerCase().includes(q),
    )
  }, [query])

  React.useEffect(() => {
    setActiveIndex(0)
  }, [query])

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Design System</h1>
      <p className="mt-1 text-sm text-foreground/70">
        Showcase de componentes globais (master-only).
      </p>
      <Separator className="my-6" />

      <Card>
        <CardHeader className="text-sm font-medium">MentionAutocomplete</CardHeader>
        <CardContent className="space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              className="rounded-md border border-[#2a2a2a] bg-[#151515] px-3 py-1.5 text-xs text-foreground/80 hover:bg-[#1f1f1f]"
              onClick={() => setActiveIndex((i) => Math.max(0, i - 1))}
            >
              ↑
            </button>
            <button
              type="button"
              className="rounded-md border border-[#2a2a2a] bg-[#151515] px-3 py-1.5 text-xs text-foreground/80 hover:bg-[#1f1f1f]"
              onClick={() => setActiveIndex((i) => Math.min(users.length - 1, i + 1))}
            >
              ↓
            </button>
            <div className="text-xs text-foreground/60">
              Selecionado: {selected?.full_name || '—'}
            </div>
          </div>

          <MentionAutocomplete
            items={users}
            activeIndex={Math.max(0, Math.min(activeIndex, users.length - 1))}
            query={query}
            onQueryChange={setQuery}
            onHoverIndex={setActiveIndex}
            onSelect={(u) => setSelected(u)}
          />
        </CardContent>
      </Card>
    </div>
  )
}
